// components/RevenueTable.tsx
import React, { useMemo, useState } from 'react';
import { useQueryRequest } from '../core/QueryRequestProvider';
import { useGetReportSummaryRevenueAll } from '../core/_query';
import { FormattedNumber, IntlProvider } from 'react-intl';
import { optionsMonthEn } from '@/app/utils';
import { KTIcon } from '@/_metronic/helpers';

const DashboardRevenueSummaryAll: React.FC = () => {

  const { state } = useQueryRequest()
  const { data: cardData } = useGetReportSummaryRevenueAll(state)

  const data = useMemo(() => {
    const result = cardData?.response?.data
    return result
  }, [cardData])

  const [expandedRows, setExpandedRows] = useState<number[]>([]);

  const toggleRow = (id: number) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };


  return (
    <div className={`card`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Dashboard Summary Revenue All</span>
        </h3>
      </div>
      <div className='card-body'>
        <div className="table-responsive">
          <table className="table table-bordered table-sm text-nowrap align-middle">
            <thead className="table-light">
              <tr>
                <th>Items</th>
                <th>YTD</th>
                <th>Budgeting</th>
                <th>Last Year</th>
                <th className='w-30px'>Action</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((row, index) => [
                // Main row
                <tr
                  key={`row-${row.name}`}
                  onClick={() => row.detail && toggleRow(index)}
                  style={{ cursor: row.detail ? 'pointer' : 'default' }}
                >
                  <td>{row.name}</td>
                  <td className="text-end">
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          row.ytd || 0
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td className="text-end">
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          row.budgeting || 0
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td className="text-end">
                    <IntlProvider locale='id'>
                      <FormattedNumber
                        value={
                          row.last_year || 0
                        }
                      />
                    </IntlProvider>
                  </td>
                  <td className="text-center">
                    <div className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-5'>
                      <KTIcon iconName='eye' className='fs-3 text-info' />
                    </div>
                  </td>
                </tr>,

                // Expanded row
                row.detail && expandedRows.includes(index) ? (
                  <tr key={`expanded-${row.name}`}>
                    <td colSpan={5} className="p-2 border">
                      <table className="table table-bordered table-sm mb-0 text-center align-middle">
                        <thead>
                          <tr style={{ backgroundColor: '#fce9db' }}>
                            <th>Items</th>
                            {row.detail.map((header, idx) => (
                              <th key={idx}>{optionsMonthEn.find((monthEn) => monthEn.value === header.month!.toString())?.label}</th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            style={{
                              backgroundColor:
                                '#fce9db',
                            }}>
                            <td>Revenue</td>
                            {row.detail?.map((val, i) => (
                              <>
                                <td key={val.month + '-' + 'revenue' + '-' + i + '-' + index}>
                                  <IntlProvider locale='id'>
                                    <FormattedNumber
                                      value={
                                        val.revenue || 0
                                      }
                                    />
                                  </IntlProvider>
                                </td>
                              </>
                            ))}
                          </tr>
                          <tr
                            style={{
                              backgroundColor:
                                '#fce9db',
                            }}>
                            <td>
                              Cost
                            </td>
                            {row.detail?.map((val, i) => (
                              <td key={val.month + '-' + 'cost' + '-' + i + '-' + index}>
                                <IntlProvider locale='id'>
                                  <FormattedNumber
                                    value={
                                      val.cost || 0
                                    }
                                  />
                                </IntlProvider>
                              </td>
                            ))}
                          </tr>
                          <tr
                            style={{
                              backgroundColor:
                                '#fce9db',
                            }}>
                            <td>
                              NOP
                            </td>
                            {row.detail?.map((val, i) => (
                              <td key={val.month + '-' + 'nop' + '-' + i + '-' + index}>
                                <IntlProvider locale='id'>
                                  <FormattedNumber
                                    value={
                                      val.nop || 0
                                    }
                                  />
                                </IntlProvider>
                              </td>
                            ))}
                          </tr>
                          <tr
                            style={{
                              backgroundColor:
                                '#d6f5d6',
                            }}>
                            <td>
                              ROI
                            </td>
                            {row.detail?.map((val, i) => (
                              <td key={val.month + '-' + 'roi' + '-' + i + '-' + index}>
                                {val.roi || '0%'}
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                ) : null,
              ])}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DashboardRevenueSummaryAll;
